import { useEffect, useState } from 'react';

interface UseWebSocketAlertProps {
  wsConnectionMessage: string;
  wsConnectionSuccess: boolean;
  autoCloseDelay?: number;
}

interface UseWebSocketAlertReturn {
  showAlert: boolean;
  handleCloseAlert: () => void;
}

const useWebSocketAlert = ({
  wsConnectionMessage,
  wsConnectionSuccess,
  autoCloseDelay = 3000,
}: UseWebSocketAlertProps): UseWebSocketAlertReturn => {
  const [showAlert, setShowAlert] = useState(true);

  useEffect(() => {
    if (wsConnectionMessage) {
      setShowAlert(true);

      // Auto-close success alert after specified delay
      if (wsConnectionSuccess) {
        const timer = setTimeout(() => {
          setShowAlert(false);
        }, autoCloseDelay);
        return () => clearTimeout(timer);
      }
    } else {
      setShowAlert(false);
    }
  }, [wsConnectionMessage, wsConnectionSuccess, autoCloseDelay]);

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  return {
    showAlert,
    handleCloseAlert,
  };
};

export default useWebSocketAlert;
